import * as type from "../types/library";

const initialState = {
  content: [],
  activeId: null,
  deletionArray: [],
  fetchAllFiles: {
    loading: true,
    error: null,
  },
  activeFileSettings: {
    name: null,
    date: null,
    password: false,
  },
  deleteFile: {
    status: null,
    loading: false,
    error: null,
  },
  unlockFile: {
    destination: null,
    status: null,
    loading: false,
    error: null,
  },
  uploadFile: {
    progress: 0,
    status: null,
    loading: false,
    error: null,
  },
  setFilePassword: {
    status: null,
    loading: false,
    error: null,
  },
  removeFilePassword: {
    status: null,
    loading: false,
    error: null,
  },
  deleteArray: {
    status: null,
    loading: false,
    error: null,
  },
  showModals: {
    uploadModal: false,
    deleteModal: false,
    settingsModal: false,
    unlockModal: false,
  },
};

export const library = (state = initialState, payload) => {
  switch (payload.type) {
    // \\ // \\ LIBRARY CONTENT // \\ // \\
    case type.REQUEST_LIBRARY_CONTENT:
      return {
        ...state,
        fetchAllFiles: {
          ...state.fetchAllFiles,
          error: null,
          loading: true,
        },
      };
    case type.REVOKE_LIBRARY_CONTENT:
      return {
        ...state,
        content: [],
        fetchAllFiles: {
          ...state.fetchAllFiles,
          error: payload.message,
          loading: false,
        },
      };
    case type.SET_LIBRARY_CONTENT:
      return {
        ...state,
        content: payload.content,
        fetchAllFiles: {
          ...state.fetchAllFiles,
          error: null,
          loading: false,
        },
      };
    case type.RESET_LIBRARY_CONTENT:
      return {
        ...state,
        content: [],
        fetchAllFiles: {
          ...state.fetchAllFiles,
          error: null,
          loading: false,
        },
      };
    // \\ // \\ SET ACTIVE FILE // \\ // \\
    case type.SET_LIBRARY_ACTIVE_FILE:
      return {
        ...state,
        activeId: payload.fileId,
      };
    // \\ // \\ CLEAR ACTIVE FILE // \\ // \\
    case type.CLEAR_LIBRARY_ACTIVE_FILE:
      return {
        ...state,
        activeId: null,
      };
    // \\ // \\ CHANGE MODAL DISPLAYS // \\ // \\
    case type.CHANGE_LIBRARY_MODALS:
      if (
        payload.modal.uploadModal === true ||
        payload.modal.uploadModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            uploadModal: payload.modal.uploadModal,
          },
        };
      } else if (
        payload.modal.deleteModal === true ||
        payload.modal.deleteModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            deleteModal: payload.modal.deleteModal,
          },
        };
      } else if (
        payload.modal.settingsModal === true ||
        payload.modal.settingsModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            settingsModal: payload.modal.settingsModal,
          },
        };
      } else if (
        payload.modal.unlockModal === true ||
        payload.modal.unlockModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            unlockModal: payload.modal.unlockModal,
          },
        };
      } else {
        return state;
      }
    // \\ // \\ UNLOCK FILE // \\ // \\
    case type.REQUEST_FILE_ACCESS:
      return {
        ...state,
        unlockFile: {
          ...state.unlockFile,
          destination: null,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_FILE_ACCESS:
      return {
        ...state,
        unlockFile: {
          ...state.unlockFile,
          destination: payload.url,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_FILE_ACCESS:
      return {
        ...state,
        unlockFile: {
          ...state.unlockFile,
          destination: null,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_FILE_ACCESS:
      return {
        ...state,
        unlockFile: {
          ...state.unlockFile,
          destination: null,
          status: null,
          loading: false,
          error: null,
        },
      };
    // \\ // \\ DELETE FILE // \\ // \\
    case type.REQUEST_FILE_DELETION:
      return {
        ...state,
        deleteFile: {
          ...state.deleteFile,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_FILE_DELETION:
      return {
        ...state,
        deleteFile: {
          ...state.deleteFile,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_FILE_DELETION:
      return {
        ...state,
        deleteFile: {
          ...state.deleteFile,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_FILE_DELETION:
      return {
        ...state,
        deleteFile: {
          ...state.deleteFile,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_FILE_UPLOAD:
      return {
        ...state,
        uploadFile: {
          ...state.uploadFile,
          progress: 0.01,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_FILE_UPLOAD:
      return {
        ...state,
        uploadFile: {
          ...state.uploadFile,
          progress: 0,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_FILE_UPLOAD:
      return {
        ...state,
        uploadFile: {
          ...state.uploadFile,
          progress: 100,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_FILE_UPLOAD:
      return {
        ...state,
        uploadFile: {
          ...state.uploadFile,
          progress: 0,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.SET_ACTIVE_FILE_SETTINGS:
      return {
        ...state,
        activeFileSettings: {
          ...state.activeFileSettings,
          name: payload.settings.name,
          date: payload.settings.uploadDate,
          password: payload.settings.password,
          key: payload.settings.key,
        },
      };
    case type.RESET_ACTIVE_FILE_SETTINGS:
      return {
        ...state,
        activeFileSettings: {
          ...state.activeFileSettings,
          name: null,
          date: null,
          password: null,
          key: null,
        },
      };
    case type.REQUEST_ADD_PASSWORD_FILE:
      return {
        ...state,
        setFilePassword: {
          ...state.setFilePassword,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_ADD_PASSWORD_FILE:
      return {
        ...state,
        setFilePassword: {
          ...state.setFilePassword,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_ADD_PASSWORD_FILE:
      return {
        ...state,
        setFilePassword: {
          ...state.setFilePassword,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_ADD_PASSWORD_FILE:
      return {
        ...state,
        setFilePassword: {
          ...state.setFilePassword,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_REMOVE_PASSWORD_FILE:
      return {
        ...state,
        removeFilePassword: {
          ...state.removeFilePassword,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_REMOVE_PASSWORD_FILE:
      return {
        ...state,
        removeFilePassword: {
          ...state.removeFilePassword,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_REMOVE_PASSWORD_FILE:
      return {
        ...state,
        removeFilePassword: {
          ...state.removeFilePassword,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_REMOVE_PASSWORD_FILE:
      return {
        ...state,
        removeFilePassword: {
          ...state.removeFilePassword,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.APPEND_FILES_DELETION_ARRAY:
      return {
        ...state,
        deletionArray: [...state.deletionArray, payload.id],
      };
    case type.SUBTRACT_FILES_DELETION_ARRAY:
      return {
        ...state,
        deletionArray: state.deletionArray.filter(
          (existing) => existing !== payload.id
        ),
      };
    case type.REQUEST_DELETE_FILE_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_DELETE_FILE_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_DELETE_FILE_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_DELETE_FILE_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: null,
          loading: false,
          error: null,
        },
      };
    default:
      return state;
  }
};
